module.exports = __webpack_public_path__ + "static/img/video-start.deee264c.png";